import React from 'react';
import Component from '@vfuk/core-span';
const Span = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Span;
